var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _g5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStar1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 25,
    viewBox: "0 0 136 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#76CD2C",
    d: "M0 .543h24v24H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.555 21.472l-5.561-4.02 3.92-1.008 1.641 5.028z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.439 14.975L21 10.968h-6.877l-2.117-6.496-2.129 6.496L3 10.955l5.562 4.02-2.13 6.497 5.562-4.02 3.445-2.477z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#76CD2C",
    d: "M28 .543h24v24H28z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.556 21.472l-5.562-4.02 3.92-1.008 1.642 5.028z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.439 14.975L49 10.968h-6.877l-2.117-6.496-2.129 6.496L31 10.955l5.562 4.02-2.13 6.497 5.562-4.02 3.445-2.477z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#76CD2C",
    d: "M56 .543h24v24H56z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.555 21.472l-5.561-4.02 3.92-1.008 1.641 5.028z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.439 14.975L77 10.968h-6.877l-2.117-6.496-2.129 6.496L59 10.955l5.562 4.02-2.13 6.497 5.562-4.02 3.445-2.477z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#76CD2C",
    d: "M84 .543h24v24H84z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.555 21.472l-5.561-4.02 3.92-1.008 1.641 5.028z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.439 14.975L105 10.968h-6.877l-2.117-6.496-2.129 6.496L87 10.955l5.562 4.02-2.13 6.497 5.562-4.02 3.445-2.477z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#DCDCE6",
    d: "M112 .543h24v24h-24z"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.555 21.472l-5.561-4.02 3.921-1.008 1.64 5.028z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.439 14.975L133 10.968h-6.877l-2.117-6.496-2.129 6.496-6.877-.013 5.562 4.02-2.13 6.497 5.562-4.02 3.445-2.477z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(2.5 4.543)",
    d: "M0 0h19v17H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(30.5 4.543)",
    d: "M0 0h19v17H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(58.5 4.543)",
    d: "M0 0h19v17H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(86.5 4.543)",
    d: "M0 0h19v17H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(114.5 4.543)",
    d: "M0 0h19v17H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar1);
export default __webpack_public_path__ + "static/media/star-1.09a556702491f64fa3ca695f2938e22f.svg";
export { ForwardRef as ReactComponent };